import { mpEventInfo } from '@/constant'
import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

const contractApi = {
  // b2g 계약서 정보 조회
  getContractInfo: () => {
    return maxios.get<DefaultResponse<res.B2gContract>>(`/b2g/contract`, {
      params: { mp_event_name: mpEventInfo.b2g계약서_정보조회 },
    })
  },
  // b2g계약서 제출
  postContract: (data: req.B2gSignature) => {
    return maxios.post<DefaultResponse<null>>(`/b2g/contract`, data, {
      params: { mp_event_name: mpEventInfo.b2g계약서_제출 },
    })
  },
  // b2g 계약서 다운로드
  downloadContractPdf: () => {
    return maxios.get<DefaultResponse<res.B2gPdfUrl>>(`/b2g/contract/pdf`, {
      params: { mp_event_name: mpEventInfo.b2g계약서_다운로드 },
    })
  },
}

export default contractApi
